import { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useGlobalFunction } from "../../../../Context/GlobalFunctionContext";
import { ShippingAddress } from "./shippingAddress";
import { OrderStatus } from "./orderStatus";
import { OrderItemList } from "./orderItemList";
import { OrderViewSkeleton } from "../../../../Skeleton/orderViewSkeleton";
import { useNoteAlert } from "../../../../Context/pleaseNote";
import { BacktoPrevious } from "../../backtoPrevious";
import { useRef } from "react";
import { OrderItemListPrint } from "./orderItemListPrint";
import { useNavigate } from "react-router-dom";
import { showAddItemToast } from "../../../../utils/cartToastManager";
import { PAGES } from "../../../../routeConfig";
import { showErrorSnackbar } from "../../../../utils/snackbarNotifications";

export const ViewOrderDetails = ({ detail }) => {
  const [orderId, setOrderId] = useState(null);
  const [orderDetail, setOrderDetail] = useState(null);
  const [orderItems, setOrderItems] = useState(null);
  const [reorderItem, seReorderItem] = useState(null);
  const [downloadClick, setDownloadClick] = useState(false);
  const { getOrderDetail, getOrderItems, reorderOrderItem, sendInvoiceSignal } = useGlobalFunction();
  const { showFlashScreen, showRestrictionAlert } = useNoteAlert();
  const printRef = useRef();
  const histroy = useNavigate();
  const invoiceEligible = JSON.parse(process.env.REACT_APP_INVOICE_ELIGIBLE_STATUS || "[]");
  useEffect(() => {
    async function loadOrderDetail(oid) {
      let response = await getOrderDetail(oid);
      if (response) {
        setOrderDetail(response);
        if (response) {
          getOrderItemsList(response.orderId);
        } else {
          showErrorSnackbar("Unable to fetch order details. Please check and try again later.");
        }
      } else {
        showErrorSnackbar("Unable to fetch order details. Please check and try again later.");
      }
    }
    if (detail) {
      loadOrderDetail(detail);
      setOrderId(detail);
    } else {
      setOrderDetail(null);
    }
  }, [detail]);

  const getOrderItemsList = async (oid) => {
    let response = await getOrderItems(oid);
    if (response) {
      const result = response.cartItem.map(({ prod_id, prod_code, qty }) => ({
        productId: parseInt(prod_id),
        sku: prod_code,
        qty: parseInt(qty),
      }));
      seReorderItem(result);
      setOrderItems(response);
    } else setOrderItems(null);
    return response;
  };
  const handlePayNowClick = async () => {
    const oid = orderDetail.orderId;
    histroy(`/Payonline/${oid}`);
  };
  const handleReorderClick = async () => {
    showFlashScreen(true);
    const cartItem = await reorderOrderItem(reorderItem);
    if (cartItem && cartItem.length > 0) {
      showAddItemToast(cartItem);
    }
    showFlashScreen(false);
  };
  const handlePrint = (event) => {
    event?.preventDefault();

    if (!printRef.current) {
      return;
    }

    const styleTags = Array.from(document.querySelectorAll('link[rel="stylesheet"], style'))
      .map((styleNode) => styleNode.outerHTML)
      .join("");

    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    iframe.setAttribute("aria-hidden", "true");
    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentWindow?.document;
    if (!iframeDoc) {
      document.body.removeChild(iframe);
      return;
    }

    iframeDoc.open();
    iframeDoc.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>Order Invoice ${orderId || ""}</title>
          ${styleTags}
        </head>
        <body>${printRef.current.innerHTML}</body>
        </html>
      `);
    iframeDoc.close();

    setTimeout(() => {
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();
      setTimeout(() => {
        if (document.body.contains(iframe)) {
          document.body.removeChild(iframe);
        }
      }, 500);
    }, 250);
  };
  const handleDownloadInvoice = async () => {
    setDownloadClick(true);
    try {
      await sendInvoiceSignal(orderDetail.orderId, orderDetail.invoiceNo);
    } catch (error) {
      console.error("Invoice download error:", error);
    } finally {
      setDownloadClick(false);
    }
  };
  return (
    <Fragment>
      {orderDetail ? (
        <div className="container-fluid container-lg">
          <div className="row">
            <div className="col-lg-12">
              <div className="acc-header py-3">
                <div className="myaccount-address">
                  <h1 className="myaccount-title mb-2">Order Invoice #:{orderDetail.invoiceNo ?? ""}</h1>
                  <div className="order-invoice">
                    <p>
                      Customer Order Number: <span>{orderDetail.poNumber}</span>
                    </p>
                    <p>
                      Invoice Date: <span>{orderDetail.invoiceDate}</span>
                    </p>
                  </div>
                </div>
                <div className="reorder-download">
                  {orderDetail.orderStatusId == 18 && (
                    <div className="button-effect">
                      <button type="submit" className="btn pay-now-green theme-primary" onClick={handlePayNowClick}>
                        Pay Now
                      </button>
                    </div>
                  )}
                  <div className="button-effect">
                    <button type="submit" className="btn btn-products theme-primary" onClick={handleReorderClick}>
                      Reorder Now
                    </button>
                  </div>
                  {invoiceEligible.includes(orderDetail.orderStatusId) && (
                    <div className="button-effect">
                      <button className="btn invoice-download" onClick={handleDownloadInvoice} disabled={downloadClick}>
                        {downloadClick ? (
                          <Fragment>
                            <i className="fas fa-spinner fa-spin" style={{ padding: "5px" }}></i> Downloading...
                          </Fragment>
                        ) : (
                          <Fragment>
                            <span className="wes wes-download" style={{ paddingRight: "5px" }} /> Download PDF
                          </Fragment>
                        )}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-3 mt-md-4 billingShipping-wrapper">
            <ShippingAddress params={orderDetail} />
            <OrderStatus data={orderDetail} />
            <OrderItemList items={orderItems} orderId={orderDetail.orderId} />
          </div>
          <BacktoPrevious className="col-lg-12" />
        </div>
      ) : (
        <OrderViewSkeleton />
      )}
    </Fragment>
  );
};
